import { render } from "./GalleryImageSort.vue?vue&type=template&id=3049a6f3&scoped=true"
import script from "./GalleryImageSort.vue?vue&type=script&lang=js"
export * from "./GalleryImageSort.vue?vue&type=script&lang=js"

import "./GalleryImageSort.vue?vue&type=style&index=0&id=3049a6f3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3049a6f3"]])

export default __exports__